import { EFontWeights } from 'utils/enums';
import { StyledDailyBonusBadge } from './style';
import { DailyBonusBadgeProps } from '../Shared/types';
import { ActionButton } from 'components/ActionButton';
import { useDailyBonusBadge } from '../Shared/hook';

// TODO
export const JunesJourneyDailyBonusBadge: React.FC<DailyBonusBadgeProps> = (
  props,
) => {
  const {
    title,
    titleWeight = EFontWeights.Bold,
    titleSize = '24px',
    badgeCoverImage,
    borderColor,
    borderWidth,
    font,
    onClickBadge,
    offerId,
  } = props;

  const { timeLeftLabel } = useDailyBonusBadge(props);

  return (
    <StyledDailyBonusBadge
      titleWeight={titleWeight}
      titleSize={titleSize}
      badgeCoverImage={badgeCoverImage}
      borderWidth={borderWidth}
      borderColor={borderColor || { colorOne: '#ffffff' }}
    >
      <div
        className="daily-bonus-badge-banner"
        onClick={() => onClickBadge?.(offerId)}
      >
        <div className="daily-bonus-badge-banner__content">
          <h2 className="daily-bonus-badge-banner__title">{title}</h2>
          {timeLeftLabel && (
            <ActionButton
              className="daily-bonus-badge-banner__action-button"
              text={timeLeftLabel}
              borderRadius={'7px'}
              width={'56px'}
              textColor="black"
              font={font}
              fontWeight="600"
            />
          )}
        </div>
      </div>
    </StyledDailyBonusBadge>
  );
};
